<script setup lang="ts">
/**
 * The × in a modal header.
 *
 * There were 43 of these across 33 files with 13 different class signatures
 * and three icon sizes (w-6, w-5, h-5 w-5). Most were a bare icon with no
 * padding at all, so the hit area was whatever the glyph happened to cover.
 *
 * One 32px square instead — the same height as a `sm` control, which is what
 * the rest of the app's chrome uses — with the icon at 20px inside it. The
 * negative margin pulls the box back by its own padding so the glyph's right
 * edge still lands on the header's px-6 gutter rather than 6px short of it.
 */
defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{ label?: string }>(), { label: 'Close' })
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    class="-mr-1.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-accent-600 disabled:cursor-not-allowed disabled:opacity-50"
    v-bind="$attrs"
  >
    <svg
      class="h-5 w-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
</template>
